import { isFunction, isObject } from 'lodash';
// Import Constants
import { DateToISOStringFormat } from 'constants/common';
// Import Services
import Helpers from 'services/Helpers';
import { Moment } from 'moment';

const { customMoment } = Helpers;

type DateType = Nullable<Date | string | number | Moment>;

const getStartDate = (dateValue?: DateType) => {
    return isObject(dateValue) && 'format' in dateValue && isFunction(dateValue.format)
        ? dateValue.format(DateToISOStringFormat)
        : customMoment(dateValue).startOf('day').format(DateToISOStringFormat);
};

const getEndDate = (dateValue?: DateType) => {
    return isObject(dateValue) && 'format' in dateValue && isFunction(dateValue.format)
        ? dateValue.startOf('day').format(DateToISOStringFormat)
        : customMoment(dateValue).startOf('day').format(DateToISOStringFormat);
};
export { getStartDate, getEndDate };
